import './Annotation.scss';
import { useState } from "react";
import __ from './../utils/translation';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Switch } from "./ui/switch"
import { Label } from "./ui/label"
import { Button } from "./ui/button"
import { Save, Trash2, Plus, MessageSquarePlus, HelpCircle, Info } from "lucide-react"
import $ from "jquery";

const Annotation = () => {

    const [annotationsEnabled, setAnnotationsEnabled] = useState(true);
    const [showHelp, setShowHelp] = useState(false);

    const handleAnoView = (state: boolean) => {
        setAnnotationsEnabled(state);

        if (state) { $(".annotation-3d").css("display", "block"); }
        else { $(".annotation-3d").css("display", "none"); }
    }

    return (
        <>
            <div className='p-2'>
                <Card className="w-full border-border/50 bg-card/95 backdrop-blur-sm p-0">
                    <CardHeader className="pb-2 pt-3 px-3">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <MessageSquarePlus className="h-5 w-5 text-primary" />
                                <CardTitle className="text-base font-semibold tracking-tight">
                                    {__('ANOTAÇÕES')}
                                </CardTitle>
                            </div>
                            <button
                                className="text-muted-foreground hover:text-foreground transition-colors"
                                onClick={() => setShowHelp(!showHelp)}
                            >
                                <Info className="h-4 w-4" />
                            </button>
                        </div>

                        {showHelp && (
                            <div className="mt-2 p-2 rounded-md bg-muted/50 text-xs text-muted-foreground space-y-1">
                                <p>• Clique <b>+</b> no 3D para adicionar</p>
                                <p>• <b>Câmera</b> salva a visualização</p>
                                <p>• <b>Lixeira</b> exclui a anotação</p>
                                <p>• <b>Lápis</b> edita o ponto no 3D</p>
                            </div>
                        )}
                    </CardHeader>

                    <CardContent className="space-y-3 p-3 pt-0">

                        <div className="flex items-center justify-between">
                            <Label
                                htmlFor="annotations-switch"
                                className="text-sm"
                            >
                                {__('Ativar anotações')}
                            </Label>

                            <Switch
                                id="annotations-switch"
                                checked={annotationsEnabled}
                                onCheckedChange={handleAnoView}
                            />
                        </div>

                        {!annotationsEnabled && (
                            <p className="text-xs text-yellow-500/80">
                                {__('As anotações não funcionam se as animações estiverem ativadas')}
                            </p>
                        )}

                        <div id="option-annotation" className="flex justify-center py-2">
                            <i className="fas fa-plus-circle" id="add-annotation"></i>
                        </div>

                        <div id="annotation"></div>

                        <div className="flex gap-2 pt-1">
                            <Button
                                variant="destructive"
                                size="sm"
                                className='flex-1 flex items-center gap-1'
                                onClick={() => {
                                    if (window.confirm(__("Remover todas as anotações?"))) {
                                        (window as any)["resetAllAnnotations"]?.();
                                    }
                                }}
                            >
                                <Trash2 className="h-3.5 w-3.5" />
                                {__('Remover Todas')}
                            </Button>

                            <Button
                                variant="outline"
                                size="sm"
                                className='flex-1 flex items-center gap-1'
                                onClick={() => (window as any)["saveAnnotationPreset"]?.()}
                            >
                                <Save className="h-3.5 w-3.5" />
                                {__('Salvar')}
                            </Button>
                        </div>

                    </CardContent>
                </Card>
            </div>
        </>
    )
}

export default Annotation
